import { Navigate, useParams } from 'react-router-dom';
import { lockedModulePath } from '@/config/moduleDefaults';

/** Redirect legacy `/org/locked/:key` to `/:key/locked`. */
export function LegacyLockedModuleRedirect() {
  const { moduleKey } = useParams<{ moduleKey: string }>();
  if (!moduleKey) {
    return <Navigate to="/pos/dashboard" replace />;
  }
  return <Navigate to={lockedModulePath(moduleKey)} replace />;
}
